import { Component, ViewChild, ElementRef } from "@angular/core";
import {
  IonicPage,
  NavController,
  Slides,
  ViewController
} from "ionic-angular";
import { CategoriesProvider } from "../../providers/categories/categories.provider";
import { TranslateService } from "@ngx-translate/core";
import { EventsProvider } from "../../providers/events/events.provider";
import { GeocodingProvider } from "../../providers/geocoding/geocoding.provider";
import { UserProvider } from "../../providers/user/user.provider";
import * as moment from 'moment';

/**
 * Generated class for the EventCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-event-create",
  templateUrl: "event-create.html"
})
export class EventCreatePage {
  categories: any = [];
  icon: any = null;
  @ViewChild(Slides) slides: Slides;

  @ViewChild("file") fileInput: ElementRef;
  fileToUpload: File = null;
  picture: any = null;
  loading: any = null;
  address_selected: any = null;
  canvas: any = {
    width: 1000,
    height: 1000
  };
  size: any = {
    width: 1000,
    height: 1000
  };
  preview: any = null;
  currentIndex: any = 0;
  canvas_ctx: any;
  i18n: string[] = [];
  search_address = "";
  address_list_default: any = [
    {
      place_id: "93434986",
      licence:
        "Data © OpenStreetMap contributors, ODbL 1.0. https://osm.org/copyright",
      osm_type: "way",
      osm_id: "80925970",
      boundingbox: ["48.1064365", "48.1072598", "-1.6949198", "-1.6935691"],
      lat: "48.1068495",
      lon: "-1.69421535784748",
      display_name:
        "Le Mabilay, 2, Rue de la Mabilais, Arsenal - Redon, Cleunay - Arsenal-Redon, Quartiers Ouest, Rennes, Ille-et-Vilaine, Bretagne, France métropolitaine, 35000, France",
      class: "building",
      type: "yes",
      importance: 0.101,
      address: {
        building: "Le Mabilay",
        house_number: "2",
        road: "Rue de la Mabilais",
        neighbourhood: "Arsenal - Redon",
        suburb: "Cleunay - Arsenal-Redon",
        city_district: "Quartiers Ouest",
        city: "Rennes",
        county: "Rennes",
        state: "Bretagne",
        country: "France",
        postcode: "35000",
        country_code: "fr"
      }
    }
  ];
  address_list: any;
  edited: boolean = false;
  event: any = {
    title: "",
    description: "",
    address: {
      place_id: null,
      title: null,
      subtitle: null,
      city: null,
      state: null,
      country: null
    },
    status: 1,
    category: "",
    users_max: 5,
    date: new Date().toISOString(),
    time_start: null,
    time_end: null,
    picture: null,
    created_by: null,
    created_at: new Date().toISOString()
  };

  step: any = 1;
  searched = false;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    private translate: TranslateService,
    private eventsProvider: EventsProvider,
    private geocodingProvider: GeocodingProvider,
    private categoriesProvider: CategoriesProvider,
    private userProvider: UserProvider
  ) {
    let today = new Date();
    let time_start = today.setHours(19, 0o0, 0o0);
    this.event.time_start = new Date(time_start).toISOString();
    let time_end = today.setHours(21, 0o0, 0o0);
    this.event.time_end = new Date(time_end).toISOString();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad EventCreatePage");
    // this.slides.lockSwipeToNext(true);
    // this.address_list = this.address_list_default;
    console.log("this.address_list", this.address_list);
    this.refresh();
  }

  async refresh() {
    this.refreshLang();
    this.categories = await this.categoriesProvider.getCategories();
    this.event.category = this.categories[0].id;
    this.slideChanged();
    this.onCategorieChange();
  }

  onCategorieChange() {
    console.log("onCategorieChange this.categories", this.categories);
    let category_index = this.categories.findIndex(category => {
      return this.event.category == category.id;
    });
    console.log("onCategorieChange category_index", category_index);
    let random_picture = this.categories[category_index].pictures[
      Math.floor(
        Math.random() * this.categories[category_index].pictures.length
      )
    ];

    console.log("onCategorieChange random_picture", random_picture);
    this.event.picture =
      "themes/" + this.categories[category_index].theme + "/" + random_picture;
  }
  async onSearchAddress() {
    console.log("onSearchAddress");
    if (this.search_address.length >= 3) {
      this.event.address.place_id = null;
      this.searched = true;
      let address_list = await this.geocodingProvider.searchAddress(
        this.search_address
      );
      this.processResults(address_list);
    }
  }

  processResults(items) {
    let results = [];
    for (let item of items) {
      let title = this.titleResult(item);
      let data = {
        place_id:item.place_id,
        display_name: item.display_name,
        lat: item.lat,
        lon: item.lon,
        title: title,
        city: item.address.city,
        county: item.address.county,
        town: item.address.town,
        state: item.address.state,
        country: item.address.country,
      };
      results.push(data);
    }
    this.address_list = results;
  }

  titleResult(result) {
    let title_results = '';
    let items = [
      "cafe",
      "pub",
      "bar",
      "restaurant",
      "building",
      "house",
      "attraction",
      "information",
      "artwork",
      "address29"
    ];
    for (let item of items) {
      if (result["address"][item]) {
        title_results = result["address"][item];
        return title_results;
      }
    }
  }

  subtitleResult(result) {
    let subtitle_results = [];
    let items = [
      "village",
      "house_number",
      "pedestrian",
      "road",
      "neighbourhood"
    ];
    for (let item of items) {
      if (result["address"][item]) {
        subtitle_results.push(result["address"][item]);
      }
    }
    return subtitle_results;
  }
  slideChanged() {
    this.currentIndex = this.slides.getActiveIndex();
    console.log("Current index is", this.currentIndex);
  }

  cancel() {
    this.viewCtrl.dismiss(null);
  }

  rangeChange() {
    console.log("rangeChange", this.event.users_max);
    // if(this.event.users_max < 49){
    //   this.step = 1;
    // }
    // if(this.event.users_max == 50){
    //   this.event.users_max = 55;
    //   this.step = 5;
    // }
    // if(this.event.users_max == 99){
    //   this.step = 10;
    // }
  }

  refreshLang() {
    // console.log("refresh lang");
    this.translate
      .get([
        "PICTURE_ADDED_TO_GALLERY",
        "PICTURE_DOWNLOADED",
        "ERROR_SAVING_GALLERY",
        "EXPORT_IN_PROGRESS",
        "TITLE_ALERT_LEAVE",
        "MESSAGE_ALERT_LEAVE",
        "SAVE",
        "LEAVE_WITHOUT_SAVE",
        "SELECT_PICTURE",
        "OK",
        "YES",
        "NO",
        "CANCEL",
        "TITLE",
        "SUBTITLE",
        "DEMO_PICTURE",
        "LOAD_FROM_LIBRARY",
        "LOAD_FROM_COMPUTER",
        "USE_CAMERA"
      ])
      .subscribe(value => {
        this.i18n = value;
        // console.log("this.i18n",this.i18n);
      });
  }
  slidePrev(){
    this.slides.slidePrev();
  }
  slideNext() {
    // this.slides.lockSwipeToNext(false);
    this.slides.slideNext();
    // this.slides.lockSwipeToNext(true);
  }

  getAddressIndex() {
    let address_index = this.address_list.findIndex(address => {
      return this.event.address.place_id == address.place_id;
    });
    return address_index;
  }
  toTimestamp(strDate){
    let  datum = Date.parse(strDate);
    return datum;
 }

 mergeDateAndTime(time){
   let date = moment(this.event.date).format('DD/MM/YYYY');
   let time_to_concat = moment(time).format('HH:mm');
   return moment(date + ' ' + time_to_concat,"DD/MM/YYYY HH:mm").toISOString();
   
 }


  async createEvent() {
    let user = await this.userProvider.getUser();
    let event = this.event;
    let address_index = this.getAddressIndex();
    console.log("address_index", address_index);
    event.address = {
      place_id:this.address_list[address_index].place_id,
      display_name: this.address_list[address_index].display_name,
      lat: this.address_list[address_index].lat,
      lon: this.address_list[address_index].lon,
      town: this.address_list[address_index].town?this.address_list[address_index].town:'',
      city: this.address_list[address_index].city?this.address_list[address_index].city:this.address_list[address_index].county,
      county: this.address_list[address_index].county,
      state: this.address_list[address_index].state,
      country: this.address_list[address_index].country,
      title: this.address_list[address_index].title?this.address_list[address_index].title:''
    };
    event.created_by = user.uid;
    event.time_start = this.mergeDateAndTime(this.event.time_start);
    event.time_end = this.mergeDateAndTime(this.event.time_end);
    event.time_finish = this.toTimestamp(event.time_end);
    event.users = [user.uid];
    event.users_max = event.users_max > 10 ? 10 + ((event.users_max-10)*5) : event.users_max;
    console.log("createEvent", event);
    let event_created = await this.eventsProvider.createEvent(event);
    console.log("event_created",event_created);
    console.log("event_created id",event_created.id);
    let user_result = await this.userProvider.incrementAll(user);
    console.log("user_result A",user_result);
    // let event_id = "9yngO3rHvEUkG6JmGkOw";
    // let event_chat: any = {
    //   event_id:event_created.id,
    //   messages: [],
    //   created_by: user.uid,
    //   created_at: new Date().toISOString()
    // };
    // let chat_result = await this.chatProvider.createChat(event_);
    // let chat_result = 'test';
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/event-create/event-create.ts